export class UserQuickOptions {
  includeMe: boolean;
  includeUnassigned: boolean;

  constructor(options: Partial<UserQuickOptions>) {
    this.includeMe = options.includeMe;
    this.includeUnassigned = options.includeUnassigned;
  }
}
